<!-- <modal id="servermsgmodal">
  <div class="modal">
      <div class="modal-body suspend-account-modal">
        <div class="close-modal" (click)="closeModal('servermsgmodal')">
          <i class="icon-cancel"></i>
        </div> -->
<!-- <p class="servermessage">Unfortunately, we’ve encountered some errors in the registration process.</p> -->
<!-- <p>The server is taking too long to respond</p> -->

<!-- <a href="#">Please try again.</a> -->
<!-- </div>
  </div>
  <div class="modal-background"></div>
</modal> -->

<div class="server_err_msg">
  <div class="modal-popup-header">
    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
      <span aria-hidden="true"><i class="fa fa-times"></i></span>
    </button>
  </div>

  <div class="servermessage"> {{serverErrorMsg}}</div>
</div>
